import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getFirstEditableComponentOnPage } from '../../Helpers/components';
import { isGoogleAddressComponent } from '../../Components/__helpers__/component.helpers';
// Custom hook for auto-focusing the first editable component on a page.

const useAutoFocusFirstEditableComponent = ({ componentId, inputRef }) => {
  const { currentPage } = useSelector((store) => store.navigation);
  const components = useSelector((store) => store.components);
  const pages = useSelector((store) => store.paging.pages);
  const { enterPhase } = useSelector((store) => store.transition);

  useEffect(() => {
    if (
      enterPhase === false &&
      !window?.__private__?.isPageTransitionInProgress
    ) {
      const firstEditableComponent = getFirstEditableComponentOnPage(
        currentPage,
        components,
        pages
      );

      if (firstEditableComponent?.component?.id === componentId) {
        if (isGoogleAddressComponent(firstEditableComponent)) {
          // Handle Google Address Input auto-focus
          const googleAddressInputElement =
            inputRef.current?.querySelector('input');
          if (googleAddressInputElement) {
            googleAddressInputElement.focus({ preventScroll: true });
          }
        } else {
          inputRef.current.focus({ preventScroll: true });
        }
      }
    }
  }, [enterPhase]);
};

export default useAutoFocusFirstEditableComponent;
